module.exports = __webpack_public_path__ + "static/media/Today.3d25ae10.jpg";